<p-button
    icon="pi pi-filter-slash"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::ClearFilter')"
    tooltipPosition="right"
    [label]="l('::ClearFilter')"
    (onClick)="onClick()">    
</p-button>